import React, { useState, useEffect, useRef } from 'react';
import { FiMessageSquare } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { NotificationsMessageItem } from './notifications-message-item';
import { useClient } from 'jsonapi-react';
import { useTranslation } from 'react-i18next';
import { useNotification } from '@/hooks/useNotification';
import { NotificationsWrapper, NotificationsToggle, NotificationsBadge, NotificationsContent, NotificationsHeader, NotificationsTitle, NotificationsReadBtn, NotificationsBody } from '@/components/custom/notifications/notifications';

export function NotificationsMessage() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const { notificationsComment, setNotificationsComment, notificationCommentCount, setNotificationCommentCount, getNotificationsComment } = useNotification();

  const client = useClient();
  const menuRef = useRef();

  async function handleReadBtn() {
    const { error } = await client.mutate('update_all/notifications', {
      notifications: notificationsComment.map(notification => notification['related-notification-ids'].map(id => ({ id: id, unread: false }))).flat()
    });

    if (!error) {
      setNotificationCommentCount(0);
      setNotificationsComment(notificationsComment.map(n => ({ ...n, unread: false })));
    }
  }

  useEffect(() => {
    const closeOnEscapeKeyDown = event => event.key === 'Escape' && isOpen && setIsOpen(false);
    const closeOnClickOutside = event => menuRef.current && !menuRef.current.contains(event.target) && setIsOpen(false);

    document.addEventListener('keydown', closeOnEscapeKeyDown);
    document.addEventListener('mouseup', closeOnClickOutside);

    getNotificationsComment();

    return () => {
      document.removeEventListener('keydown', closeOnEscapeKeyDown);
      document.removeEventListener('mouseup', closeOnClickOutside);
    };
  }, [isOpen]);

  return (
    <NotificationsWrapper
      aria-label="Mensagens"
      ref={menuRef}
    >
      <NotificationsToggle onClick={() => setIsOpen(!isOpen)}>
        <FiMessageSquare />
        {notificationCommentCount >= 1 && <NotificationsBadge>{notificationCommentCount}</NotificationsBadge>}
      </NotificationsToggle>

      {isOpen && (
        <NotificationsContent>
          <NotificationsHeader>
            <NotificationsTitle>{t('textsCommon.messagesTitle')}</NotificationsTitle>
            <NotificationsReadBtn onClick={() => (notificationCommentCount != 0 ? handleReadBtn() : '')}>{t('header.notificationRead')}</NotificationsReadBtn>
          </NotificationsHeader>

          <NotificationsBody>
            {notificationsComment.length === 0 && (
              <EmptyState
                type="notification"
                title={t('emptyState.notificationTitle')}
                variant="plain"
              />
            )}
            {notificationsComment.map(notification => (
              <NotificationsMessageItem
                notifications={notificationsComment}
                notification={notification}
                setNotificationCount={setNotificationCommentCount}
                setNotifications={setNotificationsComment}
                notificationCount={notificationCommentCount}
                key={notification.id}
              />
            ))}
          </NotificationsBody>
        </NotificationsContent>
      )}
    </NotificationsWrapper>
  );
}
